// SPDX-License-Identifier: MIT
import { t } from '../i18n/t';

export type Rung = 'web' | 'terminal' | 'desktop';

// L'indicateur d'échelle BYOAI persistant, rendu sous la barre du header.
// Les crans renvoient : ① Web → /facons (page échelle), ② Terminal → /connecter
// (parcours "Connecter mon Claude"), ③ Desktop → /download (page beta publique).
// Bug 3 fix 2026-05-28 : ③ pointait vers /facons (cul-de-sac) ; /download existe.
// Switch = navigation SPA.
export function renderModeLadder(opts: { current: Rung }): HTMLElement {
  const wrap = document.createElement('div');
  wrap.className = 'mode-ladder';
  wrap.setAttribute('data-component', 'mode-ladder');
  const rung = (id: Rung, href: string, num: string, label: string) =>
    `<a data-component="mode-rung" data-nav data-rung="${id}" href="${href}"
        class="mode-ladder__rung${id === opts.current ? ' is-current' : ''}">
        <span class="mode-ladder__num">${num}</span>${label}</a>`;
  // 2026-05-28 — operator dogfood : with the welcome app-shell sidebar on
  // the left, the previous inline single-line ("label … rungs … hint") was
  // visually off-center. Restructured as a 2-line block — rungs centered on
  // top, label + hint as one centered text line below it. The wrapper text
  // is grouped under .mode-ladder__text so both pieces center as one cluster.
  wrap.innerHTML = `
    <nav class="mode-ladder__rungs">
      ${rung('web', '/facons', '①', t('modeLadder.web'))}
      ${rung('terminal', '/connecter', '②', t('modeLadder.terminal'))}
      ${rung('desktop', '/download', '③', t('modeLadder.desktop'))}
    </nav>
    <div class="mode-ladder__text">
      <span class="mode-ladder__label">${t('modeLadder.label')}</span>
      <span class="mode-ladder__hint">${t('modeLadder.hint' + opts.current.charAt(0).toUpperCase() + opts.current.slice(1))}</span>
    </div>
  `;
  return wrap;
}
